import React from 'react';
import ReactDOM from 'react-dom/client';
import { message } from 'antd';
import boqService, { type BOQHeader } from '@/services/boq.service';
import { PrintableBOQEstimation } from '@/components/estimation/PrintableBOQEstimation';

function unwrapBoq(raw: unknown): BOQHeader {
  if (raw && typeof raw === 'object' && 'data' in raw && (raw as { data?: BOQHeader }).data) {
    return (raw as { data: BOQHeader }).data;
  }
  return raw as BOQHeader;
}

/** Fetch full BOQ (with materials & operations) and open print preview. */
export async function openBoqEstimationPrint(boqId: string): Promise<void> {
  try {
    const boq = unwrapBoq(await boqService.getById(boqId));
    if (!boq?.id) {
      message.error('BOQ not found');
      return;
    }

    const mainContent = document.querySelector('.ant-layout-content') as HTMLElement | null;
    const printContainer = document.createElement('div');
    printContainer.id = 'print-container';
    document.body.appendChild(printContainer);
    if (mainContent) mainContent.style.display = 'none';

    let root: ReactDOM.Root | null = null;
    const cleanup = () => {
      root?.unmount();
      if (printContainer.parentNode) document.body.removeChild(printContainer);
      if (mainContent) mainContent.style.display = '';
      window.removeEventListener('afterprint', cleanup);
    };

    root = ReactDOM.createRoot(printContainer);
    root.render(<PrintableBOQEstimation boq={boq} onClose={cleanup} />);
    window.addEventListener('afterprint', cleanup);
  } catch (e: unknown) {
    const err = e as { response?: { data?: { message?: string } }; message?: string };
    message.error(err?.response?.data?.message || err?.message || 'Failed to open BOQ print');
  }
}
